<template>
  <svg width="9" height="9" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="m5.702 4.502 3.15-3.145a.502.502 0 0 0-.71-.71l-3.145 3.15L1.852.647a.502.502 0 1 0-.71.71l3.15 3.145-3.15 3.145a.5.5 0 0 0 0 .71.5.5 0 0 0 .71 0l3.145-3.15 3.145 3.15a.5.5 0 0 0 .71 0 .5.5 0 0 0 0-.71l-3.15-3.145Z"
      fill="#fff"
    />
  </svg>
</template>
